


























































import SimpleMap from '../../core/components/SimpleMap.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import { formattedDate } from '../../core/utils/table-formatters';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getOnlyDateFromTimestamp,
    booleanFormatter,
    getDateFromTimestamp,
    formatDate
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Button,
    Combobox,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import moment from 'moment';

@Component({
    components: {
        Loading,
        SimpleMap,
        Combobox,
        Button,
        SimpleTable
    }
})
export default class ModalViewAllCard extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop() vehicleID: number;
    @Prop({ default: '' }) type: string;
    action: string = '';
    loading: boolean = true;
    sortByTable: string[] = [];
    sortDescTable: boolean[] = [];

    @Emit()
    editCalibration(item) {
        return item;
    }

    @Emit()
    deleteCalibration(item) {
        return item;
    }

    @Emit()
    editSetting(item) {
        return item;
    }

    @Emit()
    deleteSetting(item) {
        return item;
    }

    @Emit()
    editNote(item) {
        return item;
    }

    @Emit()
    deleteNote(item) {
        return item;
    }

    @Emit()
    downloadCsv(item) {
        return item;
    }

    @Emit()
    deleteCsv(item) {
        return item;
    }

    @Emit()
    editHarvestHomologation(item) {
        return item;
    }

    @Emit()
    deleteHarvestHomologation(item) {
        return item;
    }

    @Emit()
    editSowingHomologation(item) {
        return item;
    }

    @Emit()
    deleteSowingHomologation(item) {
        return item;
    }

    @Emit()
    ackHomologations(item) {
        return item;
    }

    @Emit()
    editManualFactor(item) {
        return item;
    }

    @Emit()
    deleteManualFactor(item) {
        return item;
    }

    @Emit()
    editIgnoredPeriod(item) {
        return item;
    }

    @Emit()
    deleteIgnoredPeriod(item) {
        return item;
    }

    @Watch('visible')
    observableVisible(value) {
        if (value) {
            this.getData();
        }
    }

    resetItems() {
        this.setTableItems([]);
        this.setTableHeaders([]);
    }

    setTableItems(items) {
        this.items = items;
    }

    setTableHeaders(headers) {
        this.sortByTable = [];
        this.sortDescTable = [];
        this.headers = headers;
    }

    editItem(item) {
        switch (this.type) {
            case 'calibrations':
                this.editCalibration(item);
                break;
            case 'settings':
                this.editSetting(item);
                break;
            case 'notes':
                console.log('nothing');
                break;
            case 'harhomologations':
                this.editHarvestHomologation(item);
                break;
            case 'sowhomologations':
                this.editSowingHomologation(item);
                break;
            case 'manualfactors':
                this.editManualFactor(item);
                break;
            case 'ignoredperiods':
                this.editIgnoredPeriod(item);
                break;
        }
    }

    deleteItem(item) {
        switch (this.type) {
            case 'calibrations':
                this.deleteCalibration(item);
                break;
            case 'settings':
                this.deleteSetting(item);
                break;
            case 'notes':
                this.deleteNote(item);
                break;
            case 'levmap':
                this.deleteCsv(item);
                break;
            case 'harhomologations':
                this.deleteHarvestHomologation(item);
                break;
            case 'sowhomologations':
                this.deleteSowingHomologation(item);
                break;
            case 'manualfactors':
                this.deleteManualFactor(item);
                break;
            case 'ignoredperiods':
                this.deleteIgnoredPeriod(item);
                break;
        }
    }

    headersSettings: Array<object> = [
        {
            text: 'Fecha',
            align: 'left',
            value: 'configuration_date',
            formatter: getOnlyDateFromTimestamp
        },
        {
            text: 'Ancho trabajo',
            align: 'center',
            value: 'work_width'
        },
        {
            text: 'RTK',
            align: 'center',
            value: 'has_rtk',
            formatter: booleanFormatter
        },
        {
            text: 'Var. Trabajo',
            align: 'center',
            value: 'work_variable',
            formatter: this.variableFormatter
        },
        {
            text: 'Var. Ignoradas',
            align: 'left',
            value: 'blacklisted_variables',
            formatter: this.formatBlacklistedVars
        },
        {
            text: 'Delay',
            align: 'center',
            value: 'work_variable_delay'
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions'
        }
    ];

    headersCalibrations: Array<object> = [
        {
            text: 'Fecha',
            align: 'left',
            value: 'date',
            formatter: getOnlyDateFromTimestamp
        },
        {
            text: 'Chacra',
            align: 'left',
            value: 'location.name'
        },
        {
            text: 'Ancho',
            align: 'center',
            value: 'work_width'
        },
        {
            text: 'Pasadas',
            align: 'center',
            value: 'calibration_passes.length'
        },
        // {
        //     text: 'ErrIni',
        //     align: 'center',
        //     value: '',
        // },
        // {
        //     text: 'ErrFin',
        //     align: 'center',
        //     value: '',
        // },
        {
            text: 'Telemetria',
            align: 'center',
            formatter: booleanFormatter,
            value: 'using_telemetry',
            class: 'pa-0'
        },
        {
            text: 'Aplicada',
            align: 'center',
            formatter: booleanFormatter,
            value: 'active_calibration',
            class: 'pa-0'
        },
        {
            text: 'Delay',
            align: 'center',
            value: 'delay'
        },
        {
            text: 'Equipo',
            align: 'left',
            value: 'operator'
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions'
        }
    ];
    headersNotes: Array<object> = [
        {
            text: 'Fecha',
            align: 'left',
            value: 'date_created',
            width: '180px',
            formatter: getOnlyDateFromTimestamp
        },
        {
            text: 'Nota',
            align: 'left',
            value: 'text'
        },
        {
            text: 'Usuario',
            align: 'center',
            value: 'created_by.username'
        },
        {
            text: 'Tipo',
            align: 'center',
            value: 'note_type',
            formatter: this.noteTypeFormatter
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions'
        }
    ];
    headersLevMap: Array<object> = [
        {
            text: 'Fecha ult levantada',
            align: 'left',
            value: 'upload_date',
            formatter: this.dateFormatter
        },
        {
            text: 'Cosecha',
            align: 'center',
            value: 'harvest.name'
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions'
        }
    ];
    headersManualFactors: Array<object> = [
        {
            text: 'Fecha Inicio',
            value: 'start_date',
            formatter: this.dateFormatter,
            sortable: true,
            width: '180px'
        },
        {
            text: 'Fecha Fin',
            value: 'end_date',
            formatter: this.dateFormatter,
            sortable: true,
            width: '180px'
        },
        {
            text: 'Factor de calibración (%)',
            value: 'calibration_factor',
            align: 'center',
            sortable: true
        },
        {
            text: 'Factor de calibración Humedad (%)',
            value: 'humidity_calibration_factor',
            align: 'center',
            sortable: true
        },
        {
            text: 'Generado por descalibración',
            value: 'automatically_generated',
            align: 'center',
            sortable: true,
            formatter: this.formatBoolean
        },
        {
            text: 'Acciones',
            value: 'actions',
            sortable: true,
            width: '80px'
        }
    ];
    headersIgnoredPeriods: Array<object> = [
        {
            text: 'Fecha Inicio',
            value: 'start_date',
            formatter: this.dateFormatterWithSeconds,
            sortable: true,
            width: '200px'
        },
        {
            text: 'Fecha Fin',
            value: 'end_date',
            formatter: this.dateFormatterWithSeconds,
            sortable: true,
            width: '200px'
        },
        {
            text: 'Cálculo area sin rendimiento',
            value: 'calculate_without_performance',
            align: 'center',
            sortable: true,
            formatter: booleanFormatter
        },
        {
            text: 'Humedad descartada',
            value: 'discard_humidity',
            align: 'center',
            sortable: true,
            formatter: booleanFormatter
        },
        {
            text: 'Humedad descartada CSV',
            value: 'discard_humidity_csv',
            align: 'center',
            sortable: true,
            formatter: booleanFormatter
        },
        {
            text: 'Rendimiento descartado',
            value: 'discard_performance',
            align: 'center',
            sortable: true,
            formatter: booleanFormatter
        },
        {
            text: 'Rendimiento descartado CSV',
            value: 'discard_performance_csv',
            align: 'center',
            sortable: true,
            formatter: booleanFormatter
        },
        {
            text: 'Segmento descartado',
            value: 'discard_segment',
            align: 'center',
            sortable: true,
            formatter: booleanFormatter
        },
        {
            text: 'Acciones',
            value: 'actions',
            sortable: true
        }
    ];

    reloadDetail: boolean = false;

    //LoadingDialog
    pendingRequest: boolean = false;
    msgLoadingDialog: string = '';
    errorResponse: any = {};
    successPost: boolean | null = null;
    failedResponse: boolean = false;

    items: Array<object> = [];
    headers: Array<object> = [];

     formatBlacklistedVars(list){
        if(list.length  > 0){
            return list.map(function(item) {
                return item['variable_id'] + ' - ' + item['description'];
            }).join(', ');
        }
        return '-'
    }

    formatBoolean(value) {
        return booleanFormatter(value);
    }

    dateFormatter(value) {
        return formattedDate(value);
    }

    dateFormatterWithSeconds(value) {
        return formattedDate(value, true);
    }

    noteTypeFormatter(noteTypeId) {
        let noteTypes = this.$_getInsuranceProperties['note_types'];
        if (noteTypes) {
            let noteTypeIndex = noteTypes.findIndex(item => Number(item['id']) === noteTypeId);
            if (noteTypeIndex !== -1) {
                return noteTypes[noteTypeIndex]['value'];
            }
        }
    }

    variableFormatter(item) {
        if (item !== null) {
            let varDescription = item['description'] !== null ? item['description'] : '';
            return item['variable_id'] + ' - ' + varDescription;
        } else {
            return '-';
        }
    }

    @Emit()
    closeModal() {
        this.setResponseFailed(false);
        this.resetItems();
    }

    mounted() {}

    getData() {
        this.loadingTable(true);
        this.resetItems();
        switch (this.type) {
            case 'calibrations':
                this.getCalibrations();
                break;
            case 'settings':
                this.getSettings();
                break;
            case 'notes':
                this.getNotes();
                break;
            case 'levmap':
                this.getLevMap();
                break;
            case 'harhomologations':
                this.getHarvestHomologations();
                break;
            case 'sowhomologations':
                this.getSowingHomologations();
                break;
            case 'manualfactors':
                this.getVehicleManualFactors();
                break;
            case 'ignoredperiods':
                this.getVehicleIgnoredPeriods();
                break;
        }
    }

    getCalibrations() {
        this.setAction('Calibraciones');

        InsuranceServices.getVehicleCalibrations(this.vehicleID)
            .then(res => {
                this.setTableItems(res['calibrations']);
                this.setTableHeaders(this.headersCalibrations);
                this.sortByTable = ['date'];
                this.sortDescTable = [true];
                this.loadingTable(false);
            })
            .catch(() => {
                this.setResponseFailed(true);
            });
    }

    getSettings() {
        this.setAction('Configuraciones');
        InsuranceServices.getVehicleConfigurations(this.vehicleID)
            .then(res => {
                this.setTableItems(res['vehicle_configs']);
                this.setTableHeaders(this.headersSettings);
                this.loadingTable(false);
            })
            .catch(() => {
                this.setResponseFailed(true);
            });
    }

    getNotes() {
        this.setAction('Notas');
        InsuranceServices.getVehicleNotes(this.vehicleID)
            .then(res => {
                this.setTableItems(res['notes']);
                this.setTableHeaders(this.headersNotes);
                this.loadingTable(false);
            })
            .catch(() => {
                this.setResponseFailed(true);
            });
    }

    getLevMap() {
        this.setAction('Levantadas de mapas');
        InsuranceServices.getVehicleLevMaps(this.vehicleID)
            .then(res => {
                this.setTableItems(res['performance_maps']);
                this.setTableHeaders(this.headersLevMap);
                this.loadingTable(false);
            })
            .catch(() => {
                this.setResponseFailed(true);
            });
    }

    getHarvestHomologations() {
        this.setAction('Homologaciones de Cosecha');
        InsuranceServices.getVehicleHarvestHomologations(this.vehicleID)
            .then(res => {
                this.setTableItems(res['homologations']);
                this.setTableHeaders(this.getHeadersHomologations());
                this.loadingTable(false);
            })
            .catch(() => {
                this.setResponseFailed(true);
            });
    }

    getSowingHomologations() {
        this.setAction('Homologaciones de Siembra');
        InsuranceServices.getVehicleSowingHomologations(this.vehicleID)
            .then(res => {
                this.setTableItems(res['homologations']);
                this.setTableHeaders(this.getHeadersHomologations());
                this.loadingTable(false);
            })
            .catch(() => {
                this.setResponseFailed(true);
            });
    }

    getVehicleManualFactors() {
        this.setAction('Factores Manuales');
        InsuranceServices.getVehicleManualFactors(this.vehicleID)
            .then(res => {
                this.setTableItems(res['calibration_factors']);
                this.setTableHeaders(this.headersManualFactors);
                this.loadingTable(false);
            })
            .catch(() => {
                this.setResponseFailed(true);
            });
    }

    getVehicleIgnoredPeriods() {
        this.setAction('Períodos Ignorados');
        InsuranceServices.getVehicleIgnoredPeriods(this.vehicleID)
            .then(res => {
                // console.log('todos los error lapses', res['error_lapses']);
                this.setTableItems(res['error_lapses']);
                this.setTableHeaders(this.headersIgnoredPeriods);
                this.loadingTable(false);
            })
            .catch(() => {
                this.setResponseFailed(true);
            });
    }

    getHeadersHomologations() {
        let headers = [
            {
                text: 'Fecha',
                align: 'left',
                value: 'date',
                formatter: getOnlyDateFromTimestamp
            },
            {
                text: 'Coordenadas',
                align: 'left',
                value: 'location',
                formatter: this.parseCoordinates
            },
            {
                text: 'Tipo de Cultivo',
                align: 'center',
                value: 'harvest_type',
                formatter: this.cropTypeFormatter
            },
            {
                text: 'Ancho Trabajo',
                align: 'center',
                value: 'work_width'
            },
            {
                text: 'Equipo Instalado (VIN)',
                align: 'center',
                value: 'current_vin'
            },
            {
                text: 'Responsable',
                align: 'center',
                value: 'user_email'
            },
            {
                text: 'Notas',
                align: 'center',
                value: 'notes'
            }
        ];
        if (this.type === 'harhomologations') {
            headers.push(
                {
                    text: 'Estado sensor flujo',
                    align: 'center',
                    value: 'flow_sensor_state',
                    formatter: this.sensorStateFormatter
                },
                {
                    text: 'Estado sensor humedad',
                    align: 'center',
                    value: 'humidity_sensor_state',
                    formatter: this.sensorStateFormatter
                }
            );
        }

        headers.push({
            text: 'Acciones',
            align: 'center',
            value: 'actions'
        });

        return headers;
    }

    cropTypeFormatter(cropTypeId) {
        let allCropTypes = this.$_getInsuranceProperties['harvest_type'];
        if (allCropTypes) {
            let cropTypeIndex = allCropTypes.findIndex(item => Number(item['id']) === cropTypeId);
            if (cropTypeIndex !== -1) {
                return allCropTypes[cropTypeIndex]['value'];
            }
        }
    }

    parseCoordinates(value) {
        if (value && value['latitude'] && value['longitude']) {
            return value['latitude'] + ' ; ' + value['longitude'];
        } else {
            return '-';
        }
    }

    setResponseFailed(value) {
        this.failedResponse = value;
    }

    sensorStateFormatter(sensorId) {
        let sensorTypes = this.$_getInsuranceProperties['sensor_states'];
        if (sensorTypes) {
            let sensorTypeIndex = sensorTypes.findIndex(item => Number(item['id']) === sensorId);
            if (sensorTypeIndex !== -1) {
                return sensorTypes[sensorTypeIndex]['value'];
            }
        }
    }

    loadingTable(value) {
        this.loading = value;
    }

    setAction(text) {
        this.action = text;
    }
}
